import React from 'react';
import { hooks } from '@lifesize/clients.sdk';
import { connect } from 'react-redux';
import { authActions, currentUserSelectors, servicesSelectors, userProfileSelectors } from '@lifesize/nucleus';
import { openFullScreenModal } from 'actions/FullScreenModal';
import { disableOnboarding } from 'actions/Onboarding';
import { JOIN_MODAL, BEGIN_LOGIN, END_LOGIN } from 'constants/JoinModal';
import JoinPage from 'components/JoinPage/JoinPage';
import { navigateToTrialPage } from 'actions/Application';
import { getQueryParams } from 'utils/UrlUtil';
import _get from 'lodash/get';
import { withRouter } from 'react-router-dom';
import { login, guestLogin } from 'actions/Auth';
import { selectIsLoggedIn } from 'selectors/auth';

const mapStateToProps = (state, ownProps) => {
  const connected = servicesSelectors.selectConnected(state);
  const isAuthActive = servicesSelectors.selectConnecting(state);
  const isGuest = userProfileSelectors.selectIsGuest(state);
  const remoteDisconnect = ownProps.callState === 'disconnected';
  const isPSTNCall = _get(state, 'app.joinModal.isPSTNVisible');
  const isAcquiringPrimaryStream = _get(state, 'nucleus.media.isAcquiringPrimaryStream');
  const guestEmail = getQueryParams().email;
  const willRetry = servicesSelectors.selectWillRetry(state);
  const reload = !isAuthActive && !connected && !willRetry;

  return ({
    isGuest,
    isAcquiringPrimaryStream,
    remoteDisconnect,
    isPSTNCall,
    email: _get(currentUserSelectors.myInfo(state), 'email'),
    guestEmail,
    isInJoinFlowCall: _get(state, 'app.joinModal.isJoinFlowCall'),
    reload,
    isLoggedIn: selectIsLoggedIn(state),
    isAuthActive
  });
};

const mapDispatchToProps = dispatch => ({
  beginLogin: () => dispatch({ type: BEGIN_LOGIN }),
  endLogin: () => dispatch({ type: END_LOGIN }),
  registeredLogin: () => (dispatch(login())),
  guestLogin: (name, extension, email, groupId) => dispatch(guestLogin(name, extension, email, groupId)),
  openJoinModal: extension => dispatch(openFullScreenModal(JOIN_MODAL, { extension, isLoggedIn: true })),
  onRemoteEndCall: () => dispatch(navigateToTrialPage()),
  disableOnboarding: () => dispatch(disableOnboarding()),
  ssoEmailCheck: email => (dispatch(authActions.ssoEmailCheck(email)))
});

const ConnectedComponent = withRouter(connect(mapStateToProps, mapDispatchToProps)(JoinPage));

const FunctionalWrapper = (props) => {
  const call = hooks.useCallState();
  return (<ConnectedComponent {...props} callState={call.state} />)
}

export {
  ConnectedComponent as JoinPageContainer
}
export default FunctionalWrapper;
